// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6272dacc","455":"0d0d3cfb","977":"598a1c82"}[chunkId] + ".chunk.js";
};